// extracted by mini-css-extract-plugin
export default {"header":"Header_header__cZEhD","logo":"Header_logo__diLvc","title":"Header_title__137w+"};